// extracted by mini-css-extract-plugin
export var body = "dont-miss-out-module--body--30711";
export var buttons = "dont-miss-out-module--buttons--34f7c";
export var date = "dont-miss-out-module--date--44138";
export var image = "dont-miss-out-module--image--c6b7e";
export var link = "dont-miss-out-module--link--1d430";
export var post = "dont-miss-out-module--post--db908";
export var posts = "dont-miss-out-module--posts--688b0";
export var section = "dont-miss-out-module--section--7d0c6";
export var title = "dont-miss-out-module--title--83374";